import React from "react";
import "./Header.css";
import { logoutUser } from "../utils/auth";

const Header = () => {
  const handleLogout = () => {
    logoutUser();
  };

  return (
    <header className="header">
      <div className="header-brand">
        <div className="header-logo-tile">
          <img src="Haqdarshak_logo.png" alt="Haqdarshak Logo" className="logo" />
        </div>
        <h2>Haqdarshak Dashboards</h2>
      </div>
      <button className="logout-button" onClick={handleLogout}>Logout</button>
    </header>
  );
};

export default Header;
